/* Predictive search uses Shopify's current catalogue and discards stale responses. */
(function () {
  const _i18n=(()=>{try{const s=document.getElementById('il-i18n');return s?JSON.parse(s.textContent):{};}catch{return {};}})();
  const t=(key,p={})=>{const v=_i18n[key]??key;return Object.entries(p).reduce((s,[k,val])=>s.replace('{'+k+'}',val),String(v));};
  if (!window.fetch) return;
  document.querySelectorAll('[data-suggest]').forEach((form, index) => {
    const input = form.querySelector('input[type="search"]');
    const panel = form.parentElement.querySelector('[data-suggest-panel]');
    if (!input || !panel) return;
    let timer, controller, revision = 0, selected = -1;
    const panelId = 'il-search-options-' + index;
    panel.id = panelId;
    panel.setAttribute('role', 'listbox');
    panel.setAttribute('aria-label', t('search.suggestions'));
    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-expanded', 'false');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-controls', panelId);
    input.setAttribute('autocomplete', 'off');

    function hide() {
      panel.hidden = true;
      panel.replaceChildren();
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
      selected = -1;
    }
    function cancel() {
      revision += 1;
      clearTimeout(timer);
      if (controller) controller.abort();
      hide();
    }
    function choose(index) {
      const rows = [...panel.querySelectorAll('a')];
      if (!rows.length) return;
      selected = (index + rows.length) % rows.length;
      rows.forEach((row, n) => {
        row.setAttribute('aria-selected', n === selected ? 'true' : 'false');
        row.style.background = n === selected ? 'var(--ink-06)' : '';
      });
      input.setAttribute('aria-activedescendant', rows[selected].id);
      rows[selected].scrollIntoView({ block: 'nearest' });
    }
    async function run(q, requestRevision) {
      controller = new AbortController();
      const url = new URL(form.action, location.href);
      url.pathname = url.pathname.replace(/\/$/, '') + '/suggest.json';
      url.search = new URLSearchParams({ q, 'resources[type]': 'product,collection', 'resources[limit]': '6' }).toString();
      try {
        const response = await fetch(url, { signal: controller.signal });
        if (!response.ok) throw new Error('Search unavailable');
        const data = await response.json();
        if (requestRevision !== revision || input.value.trim() !== q) return;
        const results = data.resources?.results || {};
        const candidates = [...(results.collections || []).map(item => ({ ...item, collection: true })), ...(results.products || [])];
        const fragment = document.createDocumentFragment();
        candidates.forEach((item, n) => {
          let target;
          try { target = new URL(item.url, location.href); } catch { return; }
          if (target.origin !== location.origin || !/^https?:$/.test(target.protocol)) return;
          const row = document.createElement('a');
          row.href = target.pathname + target.search;
          row.id = panelId + '-' + n;
          row.className = 'sg__row' + (item.collection ? ' sg__row--act' : '');
          row.setAttribute('role', 'option');
          row.setAttribute('aria-selected', 'false');
          row.tabIndex = -1;
          if (item.collection) {
            const label = document.createElement('s');
            label.textContent = panel.dataset.goTo || t('search.go_to');
            row.append(label);
          }
          const title = document.createElement(item.collection ? 'b' : 'span');
          title.textContent = item.title;
          row.append(title);
          fragment.append(row);
        });
        hide();
        panel.append(fragment);
        panel.hidden = !panel.childElementCount;
        input.setAttribute('aria-expanded', panel.hidden ? 'false' : 'true');
      } catch (error) {
        if (requestRevision === revision && error.name !== 'AbortError') hide();
      }
    }
    input.addEventListener('input', () => {
      cancel();
      const q = input.value.trim();
      if (q.length >= 2) {
        const requestRevision = revision;
        timer = setTimeout(() => run(q, requestRevision), 180);
      }
    });
    input.addEventListener('keydown', event => {
      if (event.key === 'Escape') cancel();
      if (!panel.hidden && ['ArrowDown', 'ArrowUp'].includes(event.key)) {
        event.preventDefault();
        choose(selected + (event.key === 'ArrowDown' ? 1 : -1));
      }
      if (event.key === 'Enter' && selected >= 0 && !panel.hidden) {
        event.preventDefault();
        panel.querySelectorAll('a')[selected]?.click();
      }
    });
    form.parentElement.addEventListener('focusout', event => {
      if (!form.parentElement.contains(event.relatedTarget)) cancel();
    });
    document.addEventListener('click', event => {
      if (!form.parentElement.contains(event.target)) cancel();
    });
    // Keep focus on the combobox until the link's click is dispatched.
    panel.addEventListener('mousedown', event => event.preventDefault());
  });
})();
